export const JOB_TYPE_INFO_MAP = {
  'Ausbildung & Duales Studium': { enum: 'LOW_INFO', points: 100 },
  'Praktikum, Werkstudium & Trainee': { enum: 'LOW_INFO', points: 100 },
  Quereinstieg: { enum: 'LOW_INFO', points: 100 },
  'Berufseinstieg & Junior-Positionen': { enum: 'MIXED', points: 50 },
  'Fachkräfte mit Berufserfahrung': { enum: 'MIXED', points: 50 },
  'Führungskräfte & Management': { enum: 'HIGH_INFO', points: 0 }
}

export const JOB_TYPES = Object.keys(JOB_TYPE_INFO_MAP)

export const VOLUME_OPTIONS = [
  { value: 'sehr-viele', label: 'Sehr viele Bewerbungen' },
  { value: 'viele', label: 'Viele Bewerbungen' },
  { value: 'wenige', label: 'Wenige Bewerbungen' },
  { value: 'sehr-wenige', label: 'Sehr wenige Bewerbungen' }
]

export const VOLUME_MAP = {
  'sehr-viele': { enum: 'VERY_HIGH' },
  viele: { enum: 'HIGH' },
  wenige: { enum: 'MEDIUM' },
  'sehr-wenige': { enum: 'LOW' }
}

export const HIRING_PLAN_OPTIONS = [
  { value: 'unter-10', label: 'Unter 10 Stellen' },
  { value: '10-50', label: '10 bis 50 Stellen' },
  { value: 'mehr-als-50', label: 'Mehr als 50 Stellen' }
]

export const HIRING_PLAN_MAP = {
  'unter-10': 'UNDER_10',
  '10-50': 'TEN_TO_FIFTY',
  'mehr-als-50': 'OVER_50'
}

export const ATS_OPTIONS = [
  { value: 'ja', label: 'Ja' },
  { value: 'nein', label: 'Nein' },
  { value: 'weiss-nicht', label: 'Weiß nicht' }
]

export const ATS_MAP = {
  ja: { enum: 'JA' },
  nein: { enum: 'NEIN' },
  'weiss-nicht': { enum: 'UNBEKANNT' }
}

export function infoDichteFromJobs(jobs) {
  if (!jobs || !jobs.length) return { enum: 'MIXED' }
  return jobs
    .map((j) => JOB_TYPE_INFO_MAP[j])
    .filter(Boolean)
    .reduce((max, cur) => (cur.points > max.points ? cur : max), {
      enum: 'HIGH_INFO',
      points: 0
    })
}

export function groesseFromEmployees(n) {
  if (n == null || Number.isNaN(n)) return { enum: 'UNKNOWN' }
  if (n > 1000) return { enum: 'ENTERPRISE' }
  if (n > 50) return { enum: 'KMU' }
  return { enum: 'STARTUP_KLEIN' }
}
